import { render, staticRenderFns } from "./myztyx.vue?vue&type=template&id=6805fba8&scoped=true&"
import script from "./myztyx.vue?vue&type=script&lang=js&"
export * from "./myztyx.vue?vue&type=script&lang=js&"
import style0 from "./myztyx.vue?vue&type=style&index=0&id=6805fba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805fba8",
  null
  
)

export default component.exports